import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, includes } from "lodash";

import Grid from "@material-ui/core/Grid";

import { displayData } from "../../../utils/data";
import { formatDate } from "../../../utils/date";

const NoteNew = (props) => {
  const { note } = props;

  return (
    <Grid container direction="column">
      <Grid item style={{ height: "25px" }}>
        <Grid container spacing={1}>
          <Grid item xs={6} className="bold-500 text-87">
            {get(note, ["updated_by"])}
          </Grid>
          <Grid item xs={6} className="bold-500" style={{ textAlign: "right" }}>
            {formatDate(get(note, ["updated_on"]))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item className="text-38">
        [
        {includes([2, 3, 4, 5], get(note, ["type", "id"]))
          ? I18n.get("site_summary")
          : includes([1], get(note, ["type", "id"]))
          ? I18n.get("site_human")
          : includes([10], get(note, ["type", "id"]))
          ? I18n.get("site_truck")
          : includes([11], get(note, ["type", "id"]))
          ? I18n.get("site_trailer")
          : ""}
        ]
      </Grid>
      <Grid item className="text-54" style={{ textAlign: "justify" }}>
        {displayData(get(note, ["description"]))}
      </Grid>
    </Grid>
  );
};

export default NoteNew;
